angular.module('jv.Gridster.Onload.Directive', [])
.directive('jvGridsterLoad', function() {
  return {
    link: function(scope, element, attr) {
      scope.$watch(function() {
        return element.hasClass('gridster-loaded');
      }, function(newValue, oldValue) {
        if (newValue) {
            //Broadcast an event when the gridster is loaded. So that there is no shuffling etc involved. 
            scope.$root.$broadcast('DASHBOARD_LOADED');
        }
      });
    }
  };
});